export const GET_DOCUMENTS_LIST = "get_documents_list";
export const RESET_GET_DOCUMENTS_LIST = "reset_get_documents_list";
export const GET_DOCUMENTS_LIST_SUCCESS = "get_documents_list_success";
export const GET_DOCUMENTS_LIST_FAILURE = "get_documents_list_failure";
